<template>
    <form @submit.prevent="save" class="modal">
        <div class="head">Добавление квартир</div>

        <div class="desc">Номер подъезда</div>
        <input v-model="entranceNumber" type="text">

        <div class="desc">Диапазон квартир</div>
        <div class="inputs">
            <div class="desc">От</div>
            <input v-model="fromFlat" class="left" type="text">
            <div class="desc">До</div>
            <input v-model="toFlat" type="text">
        </div>

        <div class="intercom" v-for="(id, i) in intercoms" :key="i">
            <div class="input_head">
                <div class="desc">Название домофона №{{ i + 1 }}</div>
                <img v-if="i == 0" @click="intercoms.push(null)" src="@/assets/img/black_plus.svg" alt="">
                <img v-else @click="intercoms.splice(i, 1)" src="@/assets/img/cancel.svg" alt="">
            </div>
            <input @focus="activeIntercomIndex = i" @blur="hideAutocomplete" :value="intercomName(id)" type="text">
            <div v-if="activeIntercomIndex == i" class="autocomplete">
                <div @click="setIntercom(i, intercom.id)" v-for="(intercom, j) in $store.getters.activeHouse.intercoms"
                     :key="j" class="item">{{ intercom.name }}
                </div>
            </div>
        </div>

        <div class="buttons">
            <button>Добавить</button>
            <div @click="$store.commit('changeShowModal', 'AddFlat')" class="cancel">
                <img src="@/assets/img/left_arrow.svg" alt="">
                <div class="text">Назад</div>
            </div>
        </div>

        <div @click="$store.commit('changeShowModal', 'AddFlat')" class="close">
            <img src="@/assets/img/close.svg" alt="">
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            activeIntercomIndex: null,
            entranceNumber: "",
            fromFlat: "",
            toFlat: "",
            intercoms: [null]
        }
    },
    methods: {
        intercomName(id) {
            let house = this.$store.getters.activeHouse
            if (house) {
                for (let j = 0; j < house.intercoms.length; j++) {
                    if (house.intercoms[j].id == id) {
                        return house.intercoms[j].name
                    }
                }
            }
            return ""
        },
        hideAutocomplete() {
            setTimeout(() => {
                this.activeIntercomIndex = null
            }, 300)
        },
        setIntercom(i, val) {
            this.intercoms[i] = val
        },
        async save() {
            let r = await this.$store.dispatch("request", {
                method: "POST",
                path: "/adm/flats",
                sendData: {
                    building_id: this.$store.getters.activeHouseID,
                    entrance: this.entranceNumber,
                    flats: [parseInt(this.fromFlat), parseInt(this.toFlat)],
                    panels_id: this.intercoms.filter(i => i != null)
                }
            })
            if (r.status == 200) {
                this.$store.commit("changeShowModal", "AddFlat")
                this.$store.dispatch("loadData")
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    input {
        width: 100%;
        margin-top: 16px;
        margin-bottom: 24px;
    }

    .inputs {
        display: flex;
        align-items: center;

        input {
            width: 110px;
            margin-left: 16px;
        }

        .left {
            margin-right: 27px;
        }
    }

    .intercom {
        position: relative;

        .input_head {
            width: 100%;
            display: flex;
            justify-content: space-between;

            img {
                cursor: pointer;
            }
        }

        .input:focus {
            display: none;
        }

        .autocomplete {
            position: absolute;
            top: calc(100% - 24px);
            left: 0;
            z-index: 1;
            background: #FFFFFF;
            box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.05);
            width: 100%;

            .item {
                padding: 20px;
                cursor: pointer;
                border-top: 1px solid #F6F6F7;
            }
        }
    }
}
</style>